<template>
  <div id="app">
    <div id="Return_Bar">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
        <a v-if="!urlLink" style="position: absolute; top: 9px; right: 20px; z-index: 9;" target="_blank" :href="imUrl + '/TJ_TJK_IMAction.html?token=' + imToken + '&tjkId=' + tjkInfo.id + '&userName=' + tjkInfo.realName + '&tjkNumber=' + tjkInfo.tjkNum + '&platform=assitant'">
            <img src="@/assets/images/zx.png" style="height: 30px;" alt="">
        </a>
    </div>
    <div id="text">
        <div v-if="!urlLink" class="step-list" v-for="(c, key) in courseList" :key="key" >
          <div class="step-list_top">
            <div class="list_top_left">
               <div class="circle" :class="{circle:c.passState == 'Passed',othercircle: c.passState == 'Ongoing' || c.passState == null}">
                   <div v-if="courseList.length!=1">{{key+1}}</div>
               </div>
              {{c.knowledge.title}}
              <div :class="c.passState == 'Passed'?'isgreen':'isred'">
                {{c.passState == "Passed" && c.passState!=null? "已完成" : "未完成"}}
              </div>
                <!--知识点描述-->
                <div class="step-list_under2" v-html="c.knowledge.description"></div>
            </div>
            <div class="list_top_right" style="width:200px">
                <div v-if="c.passState==null" class="lock"></div>
                <div v-else>
                    <div v-if="c.knowledgeType!='Special'">
                        <div class="spb_button" @click="goKnowledge(c,key)" v-if="c.passState == 'Ongoing'" type="primary" size="small">点击学习</div>
                        <div class="spb_button" @click="goKnowledge(c,key)" v-if="c.passState == 'Passed' " type="primary" size="small">重新学习</div>
                    </div>

                    <template v-if="c.knowledgeType=='Special'">
                      <template v-if="c.knowledge.assitantType == 'downLink'">
                        <div class="spb_button" v-if="c.passState != 'Passed' && c.knowledge.assitantType == 'downLink' && c.knowledge.downLink" @click="goDownLoadLink(c.knowledge)">点击下载</div>
                        <div class="spb_button" v-if="c.passState == 'Passed' && c.knowledge.assitantType == 'downLink' && c.knowledge.downLink" @click="goDownLoadLink(c.knowledge)">重新下载</div>
                      </template>
                      <template v-else>
                          <div class="sp_button" @click="Gorecord(c.knowledge.assitantType,c.knowledge.businessMajorId)" v-if="['fbt', 'fbtoperate','primary', 'middle', 'high','aftersaleprimary','aftersalemiddle','aftersalehigh'].includes(c.knowledge.assitantType)">练习记录</div>

                          <template v-if="c.knowledge.assitantType.endsWith('exam') ||c.knowledge.assitantType.endsWith('primary')||c.knowledge.assitantType.endsWith('middle')||c.knowledge.assitantType.endsWith('high')">
                              <div v-if="c.passState == 'Ongoing' " class="spb_button" type="primary" size="small" @click="GoPracticalOperation(c.knowledge,c.knowledge.businessMajorId,courseId,key,c.knowledge.title)">点击练习</div>
                              <div v-if="c.passState == 'Passed'  " class="spb_button" type="primary" size="small" @click="GoPracticalOperation(c.knowledge,c.knowledge.businessMajorId,courseId,key,c.knowledge.title)">重新练习</div>
                          </template>
                          <template v-else>
                              <div v-if="c.passState == 'Ongoing' " class="spb_button" type="primary" size="small" @click="GoPracticalOperation(c.knowledge,c.knowledge.businessMajorId,courseId,key,c.knowledge.title)">点击学习</div>
                              <div v-if="c.passState == 'Passed'  " class="spb_button" type="primary" size="small" @click="GoPracticalOperation(c.knowledge,c.knowledge.businessMajorId,courseId,key,c.knowledge.title)">重新学习</div>
                          </template>
                      </template>
                    </template>
                </div>



          </div>
          </div>
         <div v-if="key!=0" class="top_line" :class="{'top_isCheck':c.passState == 'Passed' ||  c.passState == 'Ongoing','top_noCheck':c.passState == null}"></div>
         <div v-if="courseList.length>1&& key!=courseList.length-1" :class="{line:c.passState == 'Passed',otherline: c.passState == 'Ongoing' || c.passState == null}"></div>
        </div>
        <!--==如果是直接传urlLink,直接装载==-->
        <div v-if="urlLink" >
            <iframe :src="urlLink" scrolling="auto" frameborder="0" class="iframe-container">
            </iframe>
        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: "examRecordList",
  data() {
    return {
     tjkInfo: {},
      tabIndex:0,
      collegeType:this.$route.query.collegeType,//记录类型，传到对练系统，记录结果存到college里
      fbtType:null,
      categoryId:null,
      courseList:[],//四级列表
      courseId:this.$route.query.courseId,
      urlLink:this.$route.query.urlLink,
      CourseLevel:null,//任务指南跳过来的,
            imUrl: API_ROOT.imUrl,
            imToken: API_ROOT.imToken
    };

  },
  // ... 其他代码
  beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.loadData();
      });
  },
  methods:{
    loadData(){
      if(this.urlLink){
          return;
      }else{
        if(this.$route.query.CourseLevel){this.CourseLevel=this.$route.query.CourseLevel}
        this.Lv3Courses()
      }
      this.getCustomerUser()
    },
    getCustomerUser() {
        this.$http.get('/customer/action/currentUser/customerUser').then(response=>{
            var result = response.data;
            if(result.success) {
                this.tjkInfo = result.data;
            }else{
                this.$alert(result.msg);
            }
        },response => {
            this.$alert('AJAX访问接口异常！');
        })
    },
      goDownLoadLink(knowledge){
          //urllink以 “//” 开头
          var urlLink = knowledge.downLink;
          urlLink = urlLink.replace('http:', '');
          urlLink = urlLink.replace('https:', '');
          window.location.href = urlLink;
          let data = {
              'courseId': this.courseId,
              'knowledgeSeq': knowledge.knowledgeSeq,//以后取消，后端不用【knowledgeSeq】参数了
              'knowledgeId': knowledge.knowledgeId,
              'assitant':true
          }

          this.$http.post(API_ROOT.college + '/course/submitKnowledgeXlk', data).then(res=> {
              var result = res.data;
              if(result.success) {
                  this.Lv3Courses();
              }else{
                  this.$alert(result.msg);
              }
          },res=> {
              this.$alert("AJAX请求接口异常（/course/submitKnowledge）！");
          })
      },
      //--在线进入实操--点击练习记录
      Gorecord(type, id) {
          if(type ==='fbtoperate'){
            type = 'fbt';
          }
          this.$router.push({
              path: "/train/OperationRecord", query: {type: type, id: id}
          })
      },
      //--在线进入实操--点击练习，测试
      GoPracticalOperation(know,id,courseId,key,name){
          if(this.fbtType == 'jingmai'){
            this.$router.push({path:'/train/FBT/jingmaiChat',
              query:{
                  sceneId:know.courseId
              }})
          }else if(this.fbtType == 'feige'){
            this.$router.push({path:'/train/FBT/doudianChat',
              query:{
                  sceneId:know.courseId
              }})
          }else {
            let targetType = know.assitantType;
            let targetId = id;
            if (targetType === 'fbtoperate') {
                targetType = 'primary';
                targetId = courseId;
            }
            this.$router.push({path:'/train/OnInline',
              query:{
                  page:'shichao',
                  type:targetType,
                  knowledgeId:know.knowledgeId,
                  courseId:courseId,
                  id:targetId,
                  knowledgeSeq:key+1,
                  key:key+1,
                  courseName:name,
                  CourseLevel:3,
                  sceneId:this.sceneId,
                  collegeType:this.collegeType,
                  showanswer:know.showanswer,
                  assitantType:know.assitantType
              }})
          }
      },
    // 返回按钮
    isreturn(){
      if(this.fbtType){
          this.$router.back()
          return;
      }
     if(this.$route.query.CourseLevel==3){
        this.$router.push({
                 path:'/train/SpecialCourses',query:{
                  sceneId:this.$route.query.sceneId,
                  trainId:this.$route.query.trainId,
                  tjkId:this.$route.query.tjkId,
                  assitantTjkId:this.$route.query.tjkId

                  }
                })
     }else if(this.$route.query.Level==4){
        this.$router.back()
     }else{
        localStorage.setItem('needSetDefaultTab2', 'false');//返回上级，要求不重新定位
        this.tabIndex=localStorage.getItem('tabIndex')
            this.$router.push({
              path:'/train/index',
              query:{
              tabIndex:this.tabIndex,
              condition:true//判断是否是基础知识点跳课程
              }
            })
     }
    },
    //前往知识点
    goKnowledge(c,key){
         if(c.knowledge.assitantType && c.knowledge.knowledgeType=='Special'){
            this.$router.push({
                path:'/train/OnInline',
                query:{
                  page:'qiannui',
                  type:c.knowledge.assitantType,
                  courseId:this.courseId,
                  knowledgeSeq:key+1,
                  showanswer:c.showanswer,
                  knowledgeId:c.knowledgeId
                }
              })
         }else{
            if (this.fbtType == 'jingmai' || this.fbtType == 'feige' || this.fbtType == 'qianniu') {
              this.$router.replace({
                 path: "/vedioDetail",
                 query:{
                 fbtType:this.fbtType,
                 courseId:this.courseId,
                 knowledgeSeq:c.knowledge.knowledgeSeq,
                 CourseLevel:this.CourseLevel,
                 sceneId:this.$route.query.sceneId,
                 trainId:this.$route.query.trainId,
                 tjkId:this.$route.query.tjkId,
                 knowledgeId:c.knowledgeId
                 }
              })
              return;
            }
             this.$router.push({
                 path: "/vedioDetail",
                 query:{
                 courseId:this.courseId,
                 knowledgeSeq:c.knowledge.knowledgeSeq,
                 CourseLevel:this.CourseLevel,
                 sceneId:this.$route.query.sceneId,
                 trainId:this.$route.query.trainId,
                 tjkId:this.$route.query.tjkId,
                 knowledgeId:c.knowledgeId
                 }
               })
         }

          },
    //三级课程
    Lv3Courses(){
      var assitantType = localStorage.getItem('assitantType');
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.courseId, 'assitantType' : assitantType})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.fbtType = result.data.fbtType;
              this.categoryId = result.data.categoryId;
              this.courseList=result.data.knowledgeRecordFullList
            } else {
              this.$alert(result.msg);
            }
          },(res) => {
            this.$alert(
              "AJAX请求接口异常（/course/getKnowledgeListXlk）！"
            );
          }
        );
    },
  }
};
</script>
<style scoped>
.isreturn{color:#000;cursor: pointer;}
/deep/.el-icon-arrow-left{color: #000;}
.step-list{margin-bottom: 20px;background:#fff;border-radius:5px ;padding: 19px 20px 20px 60px;position: relative;}
.step-list_top{display: flex;justify-content: space-between;}
.list_top_left{display: flex;}
.list_top_left{font-size: 16px;color: #262626;font-weight: bold;position: relative;left: -20px;}
.isred{color: #E53434; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;height: 18px;line-height: 16px;}
.isgreen{color: #14C034; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #D9F4DE;height: 18px;line-height: 16px;}
/deep/.el-button--small{padding: 9px 24px !important;border-radius:6px;}
/deep/.el-button--primary{background-color: #497af2;}
/deep/.el-button--primary>span{letter-spacing: 1px;}
.step-list_under2{margin-top:3px;font-size: 13px;overflow: hidden;color: #000;}
.circle{width: 20px;height: 20px;background:#1684fc;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;}
.othercircle{width: 20px;height: 20px;background:#BBBBBB;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;}
.line{
    width: 2px;

    top:41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #1684fc;
    z-index: 99;}
.otherline{
    width: 2px;

    top:41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #BBBBBB;
    z-index: 99;}
#app {
  height: 100%;
  box-sizing: border-box;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  padding: 20px 20px;
  height: 100%;
}
#text .right {
  width: 100%;
  margin-left: 10px;
}
.right-top {
  display: flex;
  justify-content: space-between;
}
.twolevel_list {
  padding: 10px 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;
  display: flex;
  margin-bottom: 20px;
}
.twolevel_list .left {
  width: 40px;
}
.twolevel_list .left .circle_state {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-top: 3px;
  margin-left: 10px;
  background: #d5d7d8;
  color: #fff;
  text-align: center;
}
.right_listleft {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}
.right_listleft > .pass {
  margin-left: 10px;
  color: #6cc080;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #6cc080;
  border-radius: 5px;
  background: #d3f6d3;
}
.right_listleft > .failed {
  margin-left: 10px;
  color: #e15062;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #e15062;
  border-radius: 5px;
  background: #ffe3e2;
}
.right_listright {
  background: #1684fc;
  color: #fff;
  padding: 5px 20px;
  border-radius: 7px;
  cursor: pointer;
}
.right_under {
  background: #f6f5f8;
  padding: 20px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 13px;
}
.right_under>div{overflow: hidden;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}
.circle_state_pass {
  background: #1684fc !important;
}
.sp_button{float:left;width: 95px;height: 28px;background: #BFD0FB;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #497AF2;text-align: center;line-height: 28px;cursor: pointer;letter-spacing: 1px;}
.spb_button{float:right;width: 95px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 28px;cursor: pointer;margin-left: 10px;letter-spacing: 1px;}
.lock{background: url('../../../assets/images/lock.png') no-repeat center;background-size: cover;width: 22px;height: 22px;position:absolute;right: 20px;}
.step-list_under{margin-top: 15px;background: #f5f6f7;padding: 19px 20px 20px 19px;font-size: 13px;overflow: hidden;color:#262626;}
.description{width:80%;}
.top_line{position:absolute;top:0;left: 29px;width:2px;height:21px;}
.top_isCheck{background:#1684fc;}
.top_noCheck{background:#BBBBBB;}
.iframe-container {
    position: absolute;
    top: 50px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;

}

</style>


// WEBPACK FOOTER //
// ./src/page/train/newservice/Secondarylist.vue